import React from 'react';
import { Eyebrow } from '../primitives';

/** PHLD.ai — The belief. The irreducible core, stated cleanly. Ivory, generous. */
export function Belief() {
  const section: React.CSSProperties = { background: 'var(--surface-canvas)' };
  const inner: React.CSSProperties = {
    maxWidth: '900px',
    margin: '0 auto',
    padding: 'var(--space-11) var(--gutter)',
    textAlign: 'center',
  };
  const statement: React.CSSProperties = {
    fontWeight: 'var(--weight-extralight)' as any,
    fontSize: 'clamp(2.1rem, 4.4vw, 3.5rem)',
    lineHeight: 1.18,
    letterSpacing: 'var(--tracking-tight)',
    color: 'var(--text-strong)',
    margin: 'var(--space-6) auto 0',
    maxWidth: '20ch',
  };
  const em: React.CSSProperties = { color: 'var(--periwinkle-deep)', fontStyle: 'normal' };
  const sub: React.CSSProperties = {
    fontSize: 'var(--text-body-l)',
    color: 'var(--text-muted)',
    margin: 'var(--space-7) auto 0',
    maxWidth: '46ch',
    lineHeight: 'var(--leading-relaxed)',
  };
  return (
    <section style={section}>
      <div style={inner}>
        <Eyebrow as="div" style={{ textAlign: 'center' }}>
          The belief
        </Eyebrow>
        <h2 style={statement}>
          Some work drains your team. Some work creates your brand. AI should erase the first and
          <span style={em}> protect the second.</span>
        </h2>
        <p style={sub}>That&apos;s what I do.</p>
      </div>
    </section>
  );
}
